import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Bar, BarChart, LabelList, Rectangle, ResponsiveContainer, Tooltip, XAxis } from 'recharts';

const Top3Chart = ({ data, loading }) => {
    const [top3Data, setTop3Data] = useState([data]);

    useEffect(() => {
        const sortedData = [...data].sort((a, b) => b.value - a.value);
        const top3 = sortedData.slice(0, 3);
        const processedData = top3.map((item, index) => ({
            ...item,
            // Use mediaUrl from backend, fallback to image, then placeholder
            mediaUrl: item.mediaUrl || item.image || 'https://placehold.co/600x400',
            mediaType: item.mediaType || 'image',
            image: item.image || 'https://placehold.co/600x400', // Keep for fallback
            fill: getBarFillColor(index) // Assign color based on the index
        }));

        setTop3Data(processedData);
    }, [data]);

    const barSize = 120;

    const getBarFillColor = (index) => {
        switch (index) {
            case 0:
                return "var(--color1)";
            case 1:
                return "var(--color2)";
            case 2:
                return "var(--color3)";
            default:
                return "#EEEEEE";
        }
    };

    const renderCustomLabel = ({ x, y, value, index }) => {
        const adjustedX = x - barSize / 5;
        const adjustedY = y - 140;
        return (
            <foreignObject x={adjustedX} y={adjustedY} width={barSize} height={100} style={{ overflow: 'visible' }}>
                <div className='d-flex flex-column justify-content-center align-items-center ms-5'>
                    <div className='image-container'>
                        {top3Data[index].mediaType === 'video' ? (
                            <video
                                src={top3Data[index].mediaUrl}
                                width={barSize}
                                height="100"
                                style={{ marginBottom: '10px', objectFit: 'cover' }}
                                className="rounded-3 small-image"
                                autoPlay
                                muted
                                loop
                                playsInline
                            />
                        ) : (
                            <img
                                src={top3Data[index].mediaUrl} // or top3Data[index].image
                                alt={top3Data[index].name}
                                className="rounded-3 small-image"
                                style={{ width: barSize, height: '100px', marginBottom: '10px', objectFit: 'contain' }}
                            />
                        )}
                        {top3Data[index].mediaType === 'video' ? (
                            <video
                                src={top3Data[index].mediaUrl}
                                width={barSize}
                     
                                data-html2canvas-ignore="true"
                                style={{ margin: '10px', objectFit: 'contain' }}
                                className="rounded-3 large-image no-capture "
                                autoPlay
                                muted
                                loop
                                playsInline
                            />
                        ) : (
                            <img
                                src={top3Data[index].image}
                                alt={top3Data[index].name}
                                data-html2canvas-ignore="true"
                                className="rounded-3 large-image no-capture "
                            />
                        )}

                    </div>
                    <div className='text-center w-100'>
                        <h5 data-html2canvas-ignore="true" className="fs-12 mb-0 wrap-text">{top3Data[index].name}</h5>
                    </div>
                </div>
            </foreignObject>
        );
    };

    const renderTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const { name, value } = payload[0]?.payload;
            return (
                <div className="custom-tooltip" style={{ backgroundColor: '#fff', border: '1px solid #ccc', padding: '10px', borderRadius: '5px' }}>
                    <p className="mb-0">{name}</p>
                    <p className="mb-0">{value}</p>
                </div>
            );
        }
        return null;
    };

    return (
        <div>
            {loading ? (
                <Skeleton height={530} width="100%" />
            ) : (
                top3Data?.length > 0 ? (
                    <ResponsiveContainer width="100%" height={530}>
                        <BarChart
                            data={top3Data}
                            margin={{ top: 150, right: 30, bottom: 0, left: 0 }}
                        >
                            <XAxis
                                dataKey="value"
                                interval={0}
                                axisLine={false}
                                tickLine={false}
                                tickFormatter={(value, index) => `Top ${index + 1}`}
                                tick={{
                                    fontSize: 16,
                                    fill: '#718096',
                                    fontFamily: 'Sora',
                                    fontWeight: '400'
                                }}
                            />
                            {/* <Tooltip content={renderTooltip} /> */}
                            <Bar
                                dataKey="value"
                                barSize={barSize}
                                radius={[10, 10, 0, 0]}
                                fill={({ payload }) => payload.fill}
                            >
                                <LabelList content={renderCustomLabel} />
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                ) : (
                    <div style={{ height: '430px' }}>
                        <p>No data available</p>
                    </div>
                )
            )}
        </div>
    );
};

export default Top3Chart;
